import { useDispatch, useSelector } from 'react-redux';

import { openBatchMessageComposer } from '../../sagas/batchMessage/actions';
import { openPricingModal } from '../../sagas/pricingModal/actions';

const useOpenBatchMessageComposer = () => {
  const dispatch = useDispatch();
  const { data: subscriptionData } = useSelector(s => s.getBillingSubscriptionInfo);
  const hasAccess = Boolean(subscriptionData.can_access_bulk_messages);

  return data => {
    if (!hasAccess) {
      dispatch(openPricingModal());
      return false;
    }
    if (data) dispatch(openBatchMessageComposer(data));
    return true;
  };
};

export default useOpenBatchMessageComposer;
